import "babel-polyfill";
import "ion-rangeslider";

import "./libs/select2.full.js";
import "./libs/jquery.validate";
import {binder} from "./libs/binder";

import {
    staticFunctions,
    headerFunction
} from "./modules/module";
import {startAnimation} from "./modules/startAnimation";
import {videoSlider} from "./modules/video-library";
import {squaresSlider} from "./modules/nk-slider.js";
import {ourCoursesSlider} from "./modules/ourCoursesSlider";
import {scrollToTop} from "./modules/scrollToTop";
import {selectTwo} from "./modules/selectTwo";
import {tabs} from "./modules/tabs";
import {productSlider} from "./modules/product-slider";
import {colourSlider} from "./modules/images-colour";
import {popups} from "./modules/popups";
import {loadAction} from "./modules/load-action";
import {dropdowns} from "./modules/dropdowns";
import {rangeSlider} from "./modules/range-slider";
import {missionSlider} from "./modules/mission-slider";
import {historySlider} from "./modules/history-slider";
import {stepSlider} from "./modules/step-slider";
import {productListSlider} from "./modules/product-list-slider";
import {expandText} from "./modules/expand-text";
import {facilitatorsSlider} from "./modules/facilitators-slider";
import {scrollTo} from "./modules/scroll-to";
import {collectionSlider} from "./modules/collection-slider";
import {sliderIngredients} from "./modules/slider-ingredients";
import {lookbookSlider} from "./modules/lookbook-slider";
import {gallerySlider} from "./modules/gallery-slider";
import {listVideoClasses} from "./modules/video-classes";
import {videoSubscriptions} from "./modules/video-subscriptions";
import {addToCalendar} from "./modules/add-to-calendar";
import {formValidate} from "./modules/formValidate";
import {sliderNumbers} from "./modules/slider-numbers";
import {ticketsByCourseCategories} from "./modules/tickets_by_course_categories";
import {collectiveFaq} from "./modules/collective-faq";
import {accountGuests} from "./modules/account-guests";
import {accountAttendees} from "./modules/account-attendees";
import {breakoutSessions} from "./modules/breakout-sessions";
import {colorFormulation} from "./modules/color-formulation";
// import {formDocebo} from "./modules/docebo";
import {timer} from "./modules/timer";
import {listStatesProvinces} from "./modules/list-states-provinces";
import {myAccount} from "./modules/my-account";
import {eventProducts} from "./modules/event-products";
import {contestRules} from "./modules/contest-rules";
import {customQuantity} from "./modules/woo-quantity";
import {customAddToCart} from "./modules/custom_add_to_cart";
import {formEducator} from "./modules/form-educator";

binder({
    bounds: {
        "body": [staticFunctions.addDevicesClasses(), startAnimation],
        ".page-up": [scrollToTop],
        ".header": headerFunction,
        ".js-squares-slider": squaresSlider,
        ".video-slider": videoSlider,
        ".our-courses-slider": ourCoursesSlider,
        "select": selectTwo,
        ".tabs": tabs,
        ".product-slider": productSlider,
        ".images-colour": colourSlider,
        ".popups": popups,
        ".load-action": loadAction,
        ".dropdown": dropdowns,
        ".range-slider": rangeSlider,
        ".our-mission": missionSlider,
        ".our-history": historySlider,
        ".expanded-text-content": expandText,
        ".facilitators": facilitatorsSlider,
        ".product-list": productListSlider,
        ".points": stepSlider,
        ".anchor-link": scrollTo,
        ".slider-collection": collectionSlider,
        ".slider-ingredients": sliderIngredients,
        ".lookbook-list": lookbookSlider,
        ".lookbook-video-list.gallery": gallerySlider,
        ".holder-video-classes": listVideoClasses,
        ".full-video-classes": videoSubscriptions,
        ".calendar-links": addToCalendar,
        ".gift-cards_form": formValidate,
        ".oceana-slider": sliderNumbers,
        ".cat-courses": ticketsByCourseCategories,
        // "#docebo_app_form": formDocebo,
        ".holder-timer": timer,
        ".list-states-provinces": listStatesProvinces,
        ".holder-my-products": myAccount,
        ".collective-faq": collectiveFaq,
        ".holder-event-products": eventProducts,
        ".hero-contest-rules": contestRules,
        ".holder-orders-guests": accountGuests,
        ".holder-orders-attendees": accountAttendees,
        ".breakout-sessions": breakoutSessions,
        ".holder-quantity": customQuantity,
        ".custom_add_to_cart": customAddToCart,
        ".create-educator": formEducator,
        ".hero-color-formulation": colorFormulation
    },
    runTests: false
});



// WEBPACK FOOTER //
// ./assets/js/global.js